import { Fragment } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'

import './assets/css/App.css'

// PAGES
import Login from './pages/auth/Login'
import Dashboard from './pages/Dashboard'
import Ranking from './pages/sys/Ranking'
import MyBets from './pages/sys/MyBets'
import Regulation from './pages/sys/Regulation'
import MyProfile from './pages/auth/MyProfile'
import Result from './pages/adm/result/Result'
import Users from './pages/adm/users/Users'
import UserForm from './pages/adm/users/UserForm'
import Relugaments from './pages/Regulaments'
import Languages from './pages/adm/languages/Languages'
import LanguageForm from './pages/adm/languages/LanguageForm'
import Groups from './pages/sys/Groups'
import GroupForm from './pages/sys/GroupForm'

export default function App() {

  return(
    <Router>
      <Fragment>
          <Routes> 
            <Route path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/regulaments' element={<Relugaments />} />
            <Route path='/dashboard' element={<PrivateRoute><Dashboard/></PrivateRoute>} />
            <Route path='/ranking' element={<PrivateRoute><Ranking/></PrivateRoute>} />
            <Route path='/my-bets' element={<PrivateRoute><MyBets/></PrivateRoute>} />
            <Route path='/my-profile' element={<PrivateRoute><MyProfile/></PrivateRoute>} />
            <Route path='/result' element={<PrivateRoute><Result/></PrivateRoute>} />
            <Route path='/users' element={<PrivateRoute><Users/></PrivateRoute>} /> 
            <Route path='/users-form' element={<PrivateRoute><UserForm/></PrivateRoute>} />
            <Route path='/users-form/:id' element={<PrivateRoute><UserForm/></PrivateRoute>} />
            <Route path='/languages' element={<PrivateRoute><Languages/></PrivateRoute>} />
            <Route path='/languages-form/:id' element={<PrivateRoute><LanguageForm/></PrivateRoute>} />
            <Route path='/groups' element={<PrivateRoute><Groups/></PrivateRoute>} />
            <Route path='/groups-form' element={<PrivateRoute><GroupForm/></PrivateRoute>} />
            <Route path='/groups-form/:id' element={<PrivateRoute><GroupForm/></PrivateRoute>} />
            <Route path='/regulation' element={<PrivateRoute><Regulation/></PrivateRoute>} />
          </Routes>
      </Fragment>
    </Router>
  )
}
